// DeleteModal.jsx
import React from 'react';
import { Modal } from 'antd';

const DeleteModal = ({ visible, onOk, onCancel }) => (
  <Modal
    title="Confirmar Exclusão"
    visible={visible}
    onOk={onOk}
    onCancel={onCancel}
    okText="Sim"
    cancelText="Não"
  >
    <p>Você tem certeza que deseja excluir este parceiro?</p>
  </Modal>
);

export default DeleteModal;
